import React, { createContext, useEffect, useState } from "react"
import { useCallback } from "react"
import { AdminUser as AdminUserType } from '../../types/AdminUser'
import { COOKIES_KEYS } from "../../utils/constants"
import { useCookies } from 'react-cookie'
import api from "../../helpers/api"
import { parseJwt } from "../../Korbantech/utils/functions"

type PropsAdminUserContext = {
  state: AdminUserType | undefined,
  setState: React.Dispatch<React.SetStateAction<AdminUserType | undefined >>
}

const DEFAULT_VALUE:PropsAdminUserContext = {
  state: undefined,
  setState: () => {}
}

const AdminUserContext = createContext( { ...DEFAULT_VALUE } )

const AdminUserContextProvider: React.FC = ( { children } ) => {

  const [ cookies, setCookie, removeCookie ] = useCookies( [ COOKIES_KEYS.admin_access_token ] )
  const [ state, setState ] = useState<AdminUserType | undefined >(  )
  const [ loading, setLoading ] = useState( true )

  const loadInitial = useCallback( async () => {
    const token = cookies[ COOKIES_KEYS.admin_access_token ]
    if( !token ) {
      setState( undefined )
      return setLoading( false )
    }

    const [ ,payload, ] = parseJwt( token )
    if( ( payload.exp * 1000 + 5000 ) < new Date().getTime() ) {
      setState( undefined )
      return setLoading( false )
    }

    const headers = {
      'Authorization': `Bearer ${token}`
    }
    await api.get<AdminUserType>( 'admin/me', { headers } ).then( res => {
      setState( {
        ...res.data,
        access_token: token
       })
    }).catch( console.log )

    return setLoading( false )
  }, [ cookies ] )


  useEffect( () => {
    let token: string | undefined = undefined
    token = state?.access_token
    if( token ){
      const [ ,payload, ] = parseJwt( token )
      const expires = payload.exp ? new Date( payload.exp * 1000 ) : undefined
      setCookie( COOKIES_KEYS.admin_access_token, token, {
        expires,
        sameSite: 'strict',
      } )
    } else { removeCookie( COOKIES_KEYS.admin_access_token ) }
  }, [ setCookie, removeCookie, state ] )

  useEffect( () => {
    loadInitial()
  }, [ loadInitial ])

  return (
    <AdminUserContext.Provider
      value={{
        state,
        setState
      }}
    >
      { !loading && children }
    </AdminUserContext.Provider>
  )
}

export { AdminUserContextProvider }
export default AdminUserContext
